export function getPTDate() {
  const d = new Date();
  const PACIFIC_TIME_OFFSET = -8;
  const utc = d.getTime() + d.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * PACIFIC_TIME_OFFSET);
  return nd;
}
